import Cookies from 'js-cookie'
import { decrypt } from './authentication'
var CryptoJS = require('crypto-js')

export const FormatNumber = (num)=>{
    
    let newNumber = Number(num)
    return  newNumber.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
export  const APP_KEY = 'gaatschool';

export const staffName = Cookies.get('gaatkaustnm')?CryptoJS.AES.decrypt(Cookies.get('gaatkaustnm'), APP_KEY).toString(CryptoJS.enc.Utf8):'null'
export const staffCode = Cookies.get('gaatkauscd')?CryptoJS.AES.decrypt(Cookies.get('gaatkauscd'), APP_KEY).toString(CryptoJS.enc.Utf8):'null'

export const groupCode = Cookies.get('gaatkagpcd')?CryptoJS.AES.decrypt(Cookies.get('gaatkagpcd'), APP_KEY).toString(CryptoJS.enc.Utf8):'null' 

export const Token = Cookies.get('gaatkamtk')?CryptoJS.AES.decrypt(Cookies.get('gaatkamtk'), APP_KEY).toString(CryptoJS.enc.Utf8):undefined
export const config = {
    headers: { 'content-type': 'multipart/form-data'}
} 
export const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };

//school name and LocalUrl should be entered manually
export const schoolName = 'GAAT INTERNATIONAL SCHOOL'
export const Currency = '₦'
export  const smsAccountUrl = 'https://www.multitexter.com';  


export const allowEdit = 'Yes'
export const allowDelete = 'Yes'



export  const ServerUrl = 'https://app.gaatschool.com/controller';
export  const ImagesUrl = 'https://app.gaatschool.com/images'; 

export  const mainUrl = 'https://sms.gaatschool.com'; 
//export const LocalUrl ='app.gaatschool.com'

export const LocalUrl ='localhost'

export  const ParentUrl= 'https://parent.gaatschool.com'; 
export  const teacherUrl = 'https://staff.gaatschool.com'; 
export  const studentUrl = 'https://learners.gaatschool.com';  
export const DatabaseName= 'gaatbtnv_db' 

export  const API_URL= 'https://api.gaatschool.com/api';
export  const API_IMAGE = 'https://api.gaatschool.com/public/images';  
export const menuLink = localStorage.getItem('kayus_link')? JSON.parse(decrypt(localStorage.getItem('kayus_link'))):[]

export const TINYMCE_KEY = ''
export const applicantUrl = 'https://applicant.gaatschool.com';
export const domain = 'https://applicant.gaatschool.com';

export const frontUrl = 'https://applicant.gaatschool.com';
export const siteLink = 'https://applicant.gaatschool.com';




export const classID = Cookies.get("clkysd") ? Cookies.get("clkysd"):undefined
export const sectionID = Cookies.get("sckayd") ? Cookies.get("sckayd") :undefined
export const reset_password = Cookies.get("tkrspw") ? Cookies.get("tkrspw") : "null";
export const PortalType = Cookies.get('portal')?Cookies.get('portal'):null;
